import PropTypes from 'prop-types'
import styles from './styles.module.css'

export const PrimaryButton = ({
  children,
  onClick,
  disabled = false,
  size = 'medium', // 'small' | 'medium' | 'large'
  withShadow = false, // Sombra opcional - usar apenas em CTAs principais
  className,
  type = 'button',
  ...props
}) => {
  const sizeClass = {
    small: styles.button_size_small,
    medium: styles.button_size_medium,
    large: styles.button_size_large,
  }[size]

  const shadowClass = withShadow ? styles.with_shadow : ''

  return (
    <button
      type={type}
      className={`${styles.button_primary_base} ${sizeClass} ${shadowClass} ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

PrimaryButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  withShadow: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
}
